module.exports = __webpack_public_path__ + "img/index_rule_2024.27387333.png";